var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6244_40615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.98866 17.115C14.405 17.115 17.9851 13.5349 17.9851 9.11855C17.9851 4.70221 14.405 1.12207 9.98866 1.12207C5.57233 1.12207 1.99219 4.70221 1.99219 9.11855C1.99219 13.5349 5.57233 17.115 9.98866 17.115Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02344 11.0265C8.02344 12.0927 8.89323 12.9906 9.98748 12.9906C11.0817 12.9906 11.9515 12.1208 11.9515 11.0265C11.9515 9.93229 11.0817 9.0625 9.98748 9.0625",
    stroke: "#FF7A2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9515 7.12713C11.9515 6.06094 11.0817 5.16309 9.98748 5.16309C8.89323 5.16309 8.02344 6.03288 8.02344 7.12713C8.02344 8.22139 8.89323 9.09118 9.98748 9.09118",
    stroke: "#FF7A2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98828 3.95605V5.16254",
    stroke: "#FF7A2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98828 12.9629V14.1694",
    stroke: "#FF7A2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.125 40.0106L16.6971 24.4385L31.5116 34.1185L55.1644 6.59375",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52 48.8767H1.51562V60.9977H7.52V48.8767Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0161 37.4014H15.0117V61.026H21.0161V37.4014Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5122 41.4414H28.5078V61.0258H34.5122V41.4414Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9223 34.2871H41.918V60.9981H47.9223V34.2871Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.477 17.6201H55.4727V60.9975H61.477V17.6201Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6244_40615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.597,
    height: 62.12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.af84ce59cd42a571e6c5b5869696ceb4.svg";
export { ForwardRef as ReactComponent };